import { css } from 'styled-components';
import { pxToRem } from '@fil-react-mixins/styled';
export default css `
  margin: 0;
  padding: 0;
  display: block;
  text-rendering: optimizeLegibility;
  margin-bottom: ${pxToRem(24)};
  font-size: inherit;

  pre & {
    font-family: monospace;
    white-space: pre;
  }
`;
